
import UpdateComponent from 'components/table/UpdateComponent';
import { getWashWithById, update } from 'controllers/Washwith';
import React, { useState, useEffect, useCallback } from 'react'
import { useParams, useHistory } from 'react-router-dom';

function UpdateWashWith() {
  const [inputText, setInputText] = useState('');

  const { id } = useParams()
  const history = useHistory();


  const handleChange = (event) => {
    setInputText(event.target.value);
  };

  const handleClick = () => {
    update({ id: id, value: inputText, label: inputText }, history)
  };

  const dataStream = useCallback(async () => {
    const wash = await getWashWithById(id);
    setInputText(wash.value)
  }, [id]);


  useEffect(() => {
    dataStream()
  }, [dataStream])

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2%' }}>
        <UpdateComponent
          lebel="Washing"
          buttonlabel="Product"
          inputText={inputText}
          handleChange={handleChange}
          handleClick={handleClick}
        />

      </div>
    </>
  )
}

export default UpdateWashWith;